import React, { useEffect, useState } from 'react';

import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import Carousel from "nuka-carousel";
import { DeliveryFaqData } from '../data/DeliveryFaqData';
import { Marker } from 'react-mark.js';
import "./DeliveryFaq.css"


function DeliveryFAQ({ searchTerm, searchBool }) {

    const [IFCAcc, setIFCAcc] = useState({ isVisible: true, isOpen: false });
    const [IECAcc, setIECAcc] = useState({ isVisible: true, isOpen: false });
    const [IEAcc, setIEAcc] = useState({ isVisible: true, isOpen: false });

    useEffect(() => {
        if (DeliveryFaqData[0].DLF.filter((item) => item.Question.toLowerCase().includes(searchTerm.toLowerCase()) || item.Answer.toLowerCase().includes(searchTerm.toLowerCase())).length == 0) {
            setIFCAcc({ ...IFCAcc, isVisible: false })
        } else
            setIFCAcc({ ...IFCAcc, isVisible: true, isOpen: true })

        if (DeliveryFaqData[0].IndustryExternalCertifications.filter((item) => item.Question.toLowerCase().includes(searchTerm.toLowerCase()) || item.Answer.toLowerCase().includes(searchTerm.toLowerCase())).length == 0) {
            setIECAcc({ ...IECAcc, isVisible: false })
        } else
            setIECAcc({ ...IECAcc, isVisible: true, isOpen: true })

        if (DeliveryFaqData[0].IndustryExperts.filter((item) => item.Question.toLowerCase().includes(searchTerm.toLowerCase()) || item.Answer.toLowerCase().includes(searchTerm.toLowerCase())).length == 0) {
            setIEAcc({ ...IEAcc, isVisible: false })
        } else
            setIEAcc({ ...IEAcc, isVisible: true, isOpen: true })

        if (searchTerm == "") {
            setIFCAcc({ ...IFCAcc, isVisible: true, isOpen: false })
            setIECAcc({ ...IECAcc, isVisible: true, isOpen: false })
            setIEAcc({ ...IEAcc, isVisible: true, isOpen: false })
        }


    }, [searchTerm, searchBool])



    return (
        <>
            <div className="genai-container" id='DevliveryFaq'>
                <Carousel
                    slidesToShow={1}
                    slidesToScroll={1}
                    defaultControlsConfig={{
                        nextButtonStyle: { display: "none" },
                        prevButtonStyle: { display: "none" },
                    }}
                    wrapAround={true}
                    dragging={false}
                >
                    <AccordionDetails>
                        {DeliveryFaqData[0].DLF
                            .filter((item) => item.Question.toLowerCase().includes(searchTerm.toLowerCase()) || item.Answer.toLowerCase().includes(searchTerm.toLowerCase()))
                            .map((item) => {
                                return (
                                    <>
                                        {item.id <= 5 && (
                                            <div className='ques-ans'>
                                                <div className="ques-content">
                                                    <span>Q.</span>
                                                    <Marker mark={searchTerm}>
                                                        <p style={{ textAlign: 'left', marginBottom: '0', marginTop: '0' }} dangerouslySetInnerHTML={{ __html: item.Question }}></p>
                                                    </Marker>
                                                </div>
                                                <div className="ans-content">
                                                    <span>A. </span>
                                                    <Marker mark={searchTerm}>
                                                        <p dangerouslySetInnerHTML={{ __html: item.Answer }}>
                                                        </p>
                                                    </Marker>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                );
                            })}
                    </AccordionDetails>

                    <AccordionDetails>
                        {DeliveryFaqData[0].DLF
                            .filter((item) => item.Question.toLowerCase().includes(searchTerm.toLowerCase()) || item.Answer.toLowerCase().includes(searchTerm.toLowerCase()))
                            .map((item) => {
                                return (
                                    <>
                                        {item.id >= 6 && item.id <= 9 && (
                                            <div className='ques-ans'>
                                                <div className="ques-content">
                                                    <span>Q.</span>
                                                    <Marker mark={searchTerm}>
                                                        <p style={{ textAlign: 'left', marginBottom: '0', marginTop: '0' }} dangerouslySetInnerHTML={{ __html: item.Question }}></p>
                                                    </Marker>
                                                </div>
                                                <div className="ans-content">
                                                    <span>A. </span>
                                                    <Marker mark={searchTerm}>
                                                        <p dangerouslySetInnerHTML={{ __html: item.Answer }}>
                                                        </p>
                                                    </Marker>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                );
                            })}
                    </AccordionDetails>

                    <AccordionDetails>
                        {DeliveryFaqData[0].DLF
                            .filter((item) => item.Question.toLowerCase().includes(searchTerm.toLowerCase()) || item.Answer.toLowerCase().includes(searchTerm.toLowerCase()))
                            .map((item) => {
                                return (
                                    <>
                                        {item.id > 10 && (
                                            <div className='ques-ans'>
                                                <div className="ques-content">
                                                    <span>Q.</span>
                                                    <Marker mark={searchTerm}>
                                                        <p style={{ textAlign: 'left', marginBottom: '0', marginTop: '0' }} dangerouslySetInnerHTML={{ __html: item.Question }}></p>
                                                    </Marker>
                                                </div>
                                                <div className="ans-content">
                                                    <span>A. </span>
                                                    <Marker mark={searchTerm}>
                                                        <p dangerouslySetInnerHTML={{ __html: item.Answer }}>
                                                        </p>
                                                    </Marker>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                );
                            })}
                    </AccordionDetails>


                </Carousel>





                {/* <p className='viewMore-btn'><a href='https://atci.lkm.delivery.accenture.com/DLF/FAQ' target='_blank' className=''>View more</a></p> */}



            </div>
        </>
    )
}

export default DeliveryFAQ;